import React from 'react';

import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import { TextField } from '@mui/material';
import useChangeEvent from '@dyl/hooks/useChangeEvent';
import indexToLetter from '@dyl/utils/indexToLetter';
import Node from '@dyl/task-types/Shared/Node';

export default function Stimulus({ index }) {
    const [stimulus, setStimulus, stimulusError] = useTaskField('items', index, 'stimulus_text');
    const onStimulusChange = useChangeEvent(setStimulus);
    return (
        <>
            <TextField
                multiline
                minRows={3}
                label={`Stimulus ${indexToLetter(index)}${index === 0 ? ' (Example)' : ''}`}
                value={stimulus}
                onChange={onStimulusChange}
                fullWidth
                variant='filled'
                error={!!stimulusError}
                helperText={stimulusError || ' '}
                InputProps={{
                    endAdornment: <Node lineId={index} side='start' />,
                }}
            />
        </>
    );
}